(function () {
addEventListener("DOMContentLoaded", function() {
    (function(app) {
        app.elms = {};
        app.model = {
            packages: []
        };
        app.elms.from = document.querySelector(".subscription-calc");
        app.elms.price = document.querySelector(".subscription-calc__price");
        app.elms.priceMain = document.querySelector(".subscription-calc__price-main");
        app.elms.priceCents = document.querySelector(".subscription-calc__price-cents");
        app.elms.bottleAmount = document.querySelector(".subscription-calc__main-bottle-amount");
        app.elms.tags = document.querySelector(".subscription-calc__tags");
        app.elms.range = document.querySelector(".subscription-calc__main-slider");
        app.elms.text = document.querySelector(".subscription-calc__text");
        app.elms.title = document.querySelector(".subscription-calc__title");
        app.elms.subtitle = document.querySelector(".subscription-calc__subtitle");
        app.elms.subtext = document.querySelector(".subscription-calc__subtext");
        app.elms.submit = document.querySelector(".subscription-calc__btn");
        app.elms.input = document.querySelector(".subscription-calc__input");
        app.elms.skip = document.querySelector(".subscription-calc__skip");
        app.elms.btnSubmit = document.getElementById("smtButton");
        var components = new function() {
            this.tagItem = function(text) {
                return '<li class="subscription-calc__tag">\n                <svg id="Group_5871" data-name="Group 5871" xmlns="http://www.w3.org/2000/svg" width="14.5" height="15.185" viewBox="0 0 14.5 15.185">\n                    <defs>\n                        <clipPath id="clip-path">\n                            <rect id="Rectangle_479" data-name="Rectangle 479" width="14.5" height="15.184" fill="#ffffff"/>\n                        </clipPath>\n                    </defs>\n                    <g id="Group_5781" data-name="Group 5781" clip-path="url(#clip-path)">\n                        <path id="Path_21067" data-name="Path 21067" d="M14.494.343a.285.285,0,0,0-.455-.281,29.468,29.468,0,0,0-4.585,4.57,39.376,39.376,0,0,0-3.119,4.9c-.114.208-.234.412-.37.651-.086-.12-.152-.206-.212-.3A9.16,9.16,0,0,0,4.433,8.278a3.746,3.746,0,0,0-1.457-.913A2.834,2.834,0,0,0,.293,8.01c-.408.318-.382.44.025.751a19.285,19.285,0,0,1,1.594,1.28,10.832,10.832,0,0,1,2.447,3.676c.165.384.306.778.466,1.164.111.266.253.349.482.281q.619-.183,1.232-.386a.92.92,0,0,0,.567-.5c.363-.787.713-1.58,1.081-2.366a44.566,44.566,0,0,1,2.839-5.171c.7-1.1,1.827-2.938,2.738-4.154a2.863,2.863,0,0,0,.516-1.163Z" transform="translate(0 -0.001)" fill="#ffffff"/>\n                    </g>\n                </svg>'.concat(text, "\n            </li>");
            };
            this.priceCents = function(cent) {
                return '<span class="subscription-calc__price-cents">'.concat(cent, "</span>");
            };
            this.hiddenInput = function(name, value) {
                var input = document.createElement("input");
                input.setAttribute("type", "hidden");
                input.setAttribute("name", name);
                input.setAttribute("value", value);
                return input;
            };
        };
        var events = new function() {
            this.bind = function() {
                app.elms.range.addEventListener("input", rangeSliderChanged);
                app.elms.skip.addEventListener("click", skip);
            };
        };
        var skip = function skip() {
            initRangeSlider();
            app.elms.btnSubmit.click();
        };
        var rangeSliderChanged = function rangeSliderChanged() {
            var pkg = app.model.packages[this.value];
            current(pkg);
        };
        var current = function current(pkg) {
            var fixedPrice = pkg.price.toFixed(2);
            var price = fixedPrice.toString().split(".")[0];
            var _fixedPrice_toString_split_;
            var cent = (_fixedPrice_toString_split_ = fixedPrice.toString().split(".")[1]) !== null && _fixedPrice_toString_split_ !== void 0 ? _fixedPrice_toString_split_ : "00";
            var max = 1500;
            app.elms.priceMain.innerHTML = price;
            app.elms.priceCents.innerHTML = "".concat(cent);
            // app.elms.tags.innerHTML = '';
            // for (let tag of pkg.tags) {
            //     app.elms.tags.innerHTML += components.tagItem(tag);
            // }
            if (pkg.bottles_capacity == null) app.elms.bottleAmount.innerHTML = "> ".concat(max);
            else app.elms.bottleAmount.innerHTML = pkg.bottles_capacity;
            app.elms.from.classList[pkg.bottles_capacity === 0 ? "add" : "remove"]("subscription-calc--software");
            app.elms.from.classList[pkg.bottles_capacity === null ? "add" : "remove"]("subscription-calc--max");
            app.elms.text.innerHTML = (pkg === null || pkg === void 0 ? void 0 : pkg.description) || "";
            if (app.elms.title) {
                app.elms.subtitle.innerHTML = "";
                app.elms.submit.innerHTML = "JETZT KOSTENLOS TESTEN";
                app.elms.title.innerHTML = "Reserviere dein Weinlager";
            }
            app.elms.subtext.innerHTML = "JETZT KOSTENLOS TESTEN";
            app.elms.price.style.display = "";
            switch(pkg.bottles_capacity){
                case 0:
                    if (app.elms.title) app.elms.title.innerHTML = "Zur Erfassung deines <br/> privaten Bestandes zuhause";
                    break;
                case null:
                    if (app.elms.title) {
                        app.elms.title.innerHTML = "Mehr Weine einlagern?";
                        app.elms.subtitle.innerHTML = "Schn\xfcre ein individuelles Sonderpaket <br/>\n                                                f\xfcr deine Weinsammlung von \xfcber <br/>\n                                                ".concat(max, " Flaschen.");
                        app.elms.submit.innerHTML = "JETZT ANGEBOT EINHOLEN";
                    }
                    app.elms.subtext.innerHTML = "WIR FINDEN F\xdcR DICH FLEXIBLE SPEZIALL\xd6SUNGEN.";
                    app.elms.price.style.display = "none";
                    break;
            }
            app.elms.input.value = pkg.id;
        };
        var initRangeSlider = function initRangeSlider() {
            var value = 1;
            var pkg = app.model.packages[value];
            current(pkg);
            app.elms.range.max = app.model.packages.length - 1;
            app.elms.range.value = value;
            events.bind();
        };
        var getPackages = function getPackages() {
            fetch("/front-end/subscription/packages").then(function(response) {
                if (!response.ok) throw new Error("HTTP error! status: ".concat(response.status));
                return response.json();
            }).then(function(data) {
                app.model.packages = data;
                initRangeSlider();
            }).catch(function(error) {
                console.error("Error fetching packages:", error);
            });
        };
        var setFromActionUrl = function setFromActionUrl() {
            var urlParams = new URLSearchParams(window.location.search);
            var id = urlParams.get("id");
            var key = urlParams.get("key");
            if (id && key) {
                var form = app.elms.from;
                form.appendChild(components.hiddenInput("id", id));
                form.appendChild(components.hiddenInput("key", key));
            }
        };
        app.init = function() {
            getPackages();
            setFromActionUrl();
        };
        app.init();
    })(window.SubscriptionCalc = window.SubscriptionCalc || {});
});

})();
//# sourceMappingURL=index.js.map
